<ng-container *transloco="let t; read: 'spaceplan'">
  <div id="editor-form-top" *ngIf="form" [formGroup]="form">
    <div class="form-group form-row mb-1">
      <label for="userName" class="col-sm-12 col-form-label">{{ t('editorUsersInviteForm.userName.label') }}:</label>
      <div class="col-sm-12">
        <div class="input-group mb-1">
          <textarea class="form-control" id="userName" name="userName" formControlName="userName" rows="5"></textarea>
        </div>
        <div *ngIf="isRequesting && form.get('userName').errors" class="invalid-feedback">
          <div class="form-error" *ngIf="form.controls['userName'].errors.required">
            {{ t('editorUsersInviteForm.userName.error.required') }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-group form-row mb-1">
      <label for="roleNo" class="col-sm-12 col-form-label">{{ t('editorUsersInviteForm.roleNo.label') }}:</label>
      <div class="col-sm-12">
        <div class="input-group">
          <select
            class="custom-select"
            id="roleNo"
            name="roleNo"
            formControlName="roleNo"
            style="border-radius: 0.25rem"
          >
            <option [ngValue]="null">{{ t('editorUsersInviteForm.roleNo.placeholder') }}</option>
            <option *ngFor="let role of userRoles" [ngValue]="role.roleNo">{{ role.name }}</option>
          </select>
        </div>
        <div *ngIf="isRequesting && form.get('roleNo').errors" class="invalid-feedback">
          <div class="form-error" *ngIf="form.controls['roleNo'].errors.required">
            {{ t('editorUsersInviteForm.roleNo.error.required') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
